export default "__VITE_ASSET__E9NnQanM__"